import React, { useState } from 'react';
// import styles from '../../../../styles';
import AlertList from 'components/AlertList';
import { useNavigate } from 'react-router-dom';

const FormWrapper = (props) => {
    const navigate = useNavigate();
    const [dirty, setDirty] = useState(false);
    const [modal, setModal] = useState(false);
    const [nextRoute, setNextRoute] = useState(null);
    const [alerts, setAlerts] = useState([]);

    const handleAddAlert = (alert) => {
    //state async issue.  May not be present with redux
        setTimeout(() => {
            reducer('ADD_ALERT', alert);
        }, 0);
    
    };

    const handleClearAlert = () => {
        reducer('CLEAR_ALERTS');
    };

    const handleNextRoute = () => {
        reducer('FORM_IS_CLEAN');
    //state async issue.  May not be present with redux
        setTimeout(() => {
            if (nextRoute && nextRoute.pathname) {
                navigate(`${nextRoute.pathname}`);
            }
        }, 0);
    
    };

    const handleDirtyForm = () => {
        reducer('FORM_IS_DIRTY');
    };

    const reducer = (action, data = null) => {
        switch(action) {
        case 'FORM_IS_DIRTY':
            setDirty(true);
            break;
        case 'FORM_IS_CLEAN':
            setDirty(false);
            break;
        case 'SHOW_MODAL':
            setModal(true);
            break;
        case 'SET_NEXT_ROUTE':
            setNextRoute(data);
            break;
        case 'ADD_ALERT':
            setAlerts((currentAlerts) => [...currentAlerts, data]);
            break;
        case 'CLEAR_ALERTS':
            setAlerts([]);
            break;
        }
    };
  
    const styles = {
        navBar: {
            marginBottom: '100px'
        },
        icon: {
            marginLeft: '10px'
        },
        listIcon: {
            marginRight: '10px'
        },
        pageHeading: {
            paddingBottom: '50px'
        },
        transparentBg: {
            background: 'transparent'
        },
        alerts: {
            marginBottom: '10px',
            minHeight: '50px'
        },
        ataTextDiv: {
            position: 'relative',
            width: '250px',
            textAlign: 'left',
            height: '100%'
        },
        ataText: {
            width: "250px",
            transition: "all 0.5s ease",
            ':focus': {
                width: "400px"
            }
        },
        ataResults: {
            position: 'absolute',
            marginTop: '10px',
            marginLeft: '5px',
            width: '400px',
            minHeight: '200px',
            background: '#F6F6F6',
            borderTop: '1px solid #fffcfc',
            borderLeft: '1px solid #fffcfc',
            borderBottom: '1px solid #998f8f',
            borderRight: '1px solid #998f8f',
            borderRadius: '10px',
            boxShadow: '5px 5px 10px 10px rgba(0,0,0,0.5)'
        }
    };

    const childForms = React.Children.map(props.children,
     (child) => React.cloneElement(child, {
         onDirtyForm: handleDirtyForm,
         isDirty: dirty,
         addAlert: handleAddAlert,
         clearAlerts: handleClearAlert,
         formErrors: props.formErrors
     })
    );

    return (
      <div>
      {
          props.formErrors !=undefined && props.formErrors.length > 0?
          <div>
            <div className="text-center" style={styles.alerts}>
            {
                <AlertList alerts={props.formErrors} />
            }
            </div>
            <div className="text-center">
                {childForms}
            </div>
          </div>: 
          false
      }
      </div>
    );
};

export default FormWrapper;